import { StatusSelect, type StatusSelectProps } from './StatusSelect'
import { StatusBadge } from './StatusBadge'

//hide table scroll
import './PostDialog/PostDialog.scss'

export type StatusCellProps = Pick<StatusSelectProps, 'value' | 'onChange'> & {
    className?: string
}

export const StatusCell = ({ value, onChange, className }: StatusCellProps) => {
    return value === 'published' ? (
        <StatusBadge className={className} value={value} />
    ) : (
        <StatusSelect
            value={value}
            onChange={onChange}
            classNameTrigger={className}
            classNameContent={'w-[139px]'}
        />
    )
}
